import { makeAutoObservable, runInAction } from 'mobx'
import { cloneDeep, sortBy, pick, keyBy, reverse, forEach, map } from '@dt/fe-utils/dist/lodash'
import { restaurantCenter, restaurantConfig, cartMobx } from '..'
import { ddayjs, format, getDistance, toDecimal, coordtransform } from '@dt/fe-utils'
import { defaultConfig, checkInTime } from './center/cookware'
import StoreAPI from 'api/store.api'

/** channel eattype 组合 */
export enum TChannelEatType {
  callPospickup = 'callPospickup',
  groupMealdelivery = 'groupMealdelivery',
  groupMealdinein = 'groupMealdinein',
  groupMealpickup = 'groupMealpickup',
  mobiledinein = 'mobiledinein',
  mobiletogo = 'mobiletogo',
  posdinein = 'posdinein',
  postogo = 'postogo',
  selfDeliverydelivery = 'selfDeliverydelivery',
  selfDeliverypickup = 'selfDeliverypickup',
}

/**
 * 就餐方式枚举类型
 */
export enum TEEatType {
  pickup = 'pickup',
  delivery = 'delivery',
  togo = 'togo',
  dinein = 'dinein',
  mall = 'mall',
  redeemCouponByMoney = 'redeemCouponByMoney',
  carside = 'carside',
}

/**
 * 排序城市名称
 * @param list 城市列表
 * @param lang 语言
 * @returns {string[]}
 */
const sortCityNames = (list: string[]) => {
  list = list.sort((a, b) => {
    return a.localeCompare(b)
  })
  return list
}

const timeDifference = (startTime: string, endTime: string): number => {
  const startF = startTime.split(':')
  const startAll = (Number(startF[0]) * 60 * 60 + Number(startF[1]) * 60 + Number(startF[2])).toFixed()
  const endF = endTime.split(':')
  const endAll = (Number(endF[0]) * 60 * 60 + Number(endF[1]) * 60 + Number(endF[2])).toFixed()
  return parseInt(String(Number(endAll) - Number(startAll)))
}

const ALLDAY = [{ 'day': 1, 'list': [{ 'begin': '00:00', 'end': '24:00' }] }, { 'day': 2, 'list': [{ 'begin': '00:00', 'end': '24:00' }] }, { 'day': 3, 'list': [{ 'begin': '00:00', 'end': '24:00' }] }, { 'day': 4, 'list': [{ 'begin': '00:00', 'end': '24:00' }] }, { 'day': 5, 'list': [{ 'begin': '00:00', 'end': '24:00' }] }, { 'day': 6, 'list': [{ 'begin': '00:00', 'end': '24:00' }] }, { 'day': 7, 'list': [{ 'begin': '00:00', 'end': '24:00' }] }]

// TODO 可以再优化一次计算速度
const calInSale = (saleTime: ISaleTime[], timeZone: any, nowStamp: number) => {
  let isCountDown = 0
  const curDay = new Date().getDay()
  const day = curDay === 0 ? 7 : curDay // 存储当前是星期几
  const times = (saleTime || []).find((item: any) => {
    return item.day === day
  })
  if (times) {
    const valueTime = ddayjs(timeZone).format('HH:mm:ss')
    const _time = times.list.find((time) => {
      const beginTime = time.begin.split(':').join('')
      const endTime = time.end.split(':').join('')
      const now = valueTime.substr(0, 5).split(':').join('')
      if (now >= beginTime && now < endTime) {
        const endDiff = timeDifference(valueTime, `${time.end}:00`)
        isCountDown = endDiff
        return true
      } else {
        // 跨天营业时间
        if (endTime > '2400') {
          const nEnd = `${Number(endTime) - 2400}`
          const nEndH = nEnd.substr(0, nEnd.length - 2)
          const nEndM = nEnd.substr(-2)
          const _begin = '00:00'
          const _end = `0${nEndH}`.substr(-2) + `:${nEndM}`
          const _beginTime = _begin.split(':').join('')
          const _endTime = _end.split(':').join('')
          if (now >= _beginTime && now < _endTime) {
            const endDiff = timeDifference(valueTime, `${_end}:00`)
            isCountDown = endDiff
            return true
          }
        }
        const beginDiff = timeDifference(valueTime, `${time.begin}:00`)
        isCountDown = beginDiff
        return false
      }
    })
    return { inSale: !!_time, isCountDown, valueTime: nowStamp }
  }
  return { inSale: false, isCountDown, valueTime: 0 }
}

/**
 * 通过经纬度计算距离并(带单位)
 * @param lbsLat
 * @param lbsLng
 * @param otherLbs 其他的经纬度，不传默认用户定位
 * @returns {string}
 */
const getDistanceAndUnit = (lbsLat: number, lbsLng: number, otherLbs?: { lat: number; lng: number }) => {
  let lbs = restaurantConfig.lbs
  if (otherLbs && otherLbs.lat && otherLbs.lng) {
    lbs = otherLbs
  }
  const distance = getDistance(lbs?.lat, otherLbs?.lng || lbs?.lng, lbsLat, lbsLng)
  let distanceWithUnit = ''
  if (bo === 'cn') {
    if (distance < 100) {
      distanceWithUnit = '小于100米'
    } else if (distance < 1000) {
      distanceWithUnit = parseInt(distance + '') + 'm'
    } else {
      distanceWithUnit = toDecimal(distance / 1000, 1) + 'km'
    }
  } else {
    const distanceNum = toDecimal(distance / 1000, 1)
    if (distanceNum < 0.1) {
      distanceWithUnit = '<0.1 miles'
    } else {
      distanceWithUnit = distanceNum + 'miles'
    }
  }
  return { distance, distanceWithUnit }
}

/** 门店已购数量 */
interface IStoreBought {
  storeId: number | string;
  cnt: number | string;
}

class Store {
  constructor () {
    makeAutoObservable(this)
    if (!localStorage.getItem('browserUuidId') && !window.cordova) {
      restaurantCenter.on(restaurantCenter.RESTAURANT_EVENT.CONFIG_MEMBER_CHANGED, (data) => {
        data?.id && this.getStoreBought(String(data?.id))
      })
    }
  }

  /** 加载中 */
  isLoading = true

  /** 品牌信息 */
  brand: IBrand = {
    brandId: 0,
    brandName: '',
    logo: defaultConfig.brandLogo,
    bo,
    timeZone: 'Asia/Shanghai'
  }

  /** 扩展的消费数据，当前登录用户的消费数据 */
  saleCntMap: {
    [storeId: number]: number;
  } = {}

  /** 所有门店(for mobile) */
  storeList = [] as IStore[]

  /** 购买过的门店(for mobile) */
  storeBoughtList = [] as IStoreBought[]

  /** 城市名称 */
  cityName: string = ''

  /** 城市门店列表 */
  storeCityList: string[] = []

  /** 门店开启的手机端点单流程就餐方式 */
  storeEatTypeMap: { [storeId: string]: string[] } = {}
  storeSceneMap: { [storeId: string]: { [eatType: string]: IStoreSceneInfo } } = {}

  /** 门店信息(inner) */
  _info: IViewStore = {
    storeId: 0, // restaurantConfig.storeId,
    brandId: 0, // restaurantConfig.brandId,
    isMobileOrder: 1,
    // isMultiMenu: 1,
    inSale: 1,
    status: 'inSale',
    saleTime: ALLDAY,
    countDownDiff: 0,
    baseTimeStamp: 0
  } as any as IViewStore

  /** 品牌码下可切换的就餐方式 */
  openBrandEatTypes: ('dinein' | 'pickup' | 'delivery')[] = ['pickup']

  /** 门店信息 */
  get info (): IViewStore {
    // const eatTypeMap = restaurantConfig.codeType === 'table' ? this._info.deskOrderMode : this._info.storeOrderMode
    // const eatType = Object.keys(pickBy(eatTypeMap)).filter(eatType => restaurantConfig.codeType === 'table' ? eatType === 'dinein' : eatType === 'togo') as ('dinein' | 'togo')[]
    // 门店码和桌码默认堂食
    const eatType = ('table_store'.includes(`${restaurantConfig?.codeType}`) ? ['dinein'] : this._info.sceneEatTypes) as ('dinein' | 'togo' | 'pickup' | 'delivery')[]
    const { distance = 0, distanceWithUnit = '' } = (restaurantConfig?.lbs?.lat || (cartMobx.info.eatType === TEEatType.delivery && restaurantConfig.addressLbs?.lat)) ? getDistanceAndUnit(this._info.lbsLat, this._info.lbsLng, cartMobx.info.eatType === TEEatType.delivery && restaurantConfig.addressLbs?.lat ? restaurantConfig.addressLbs : undefined) : {}
    const payMode = restaurantConfig.app === 'pos' ? this._info.payMode : restaurantConfig.codeType === 'table' ? 1 : 0
    const _boughtObj = keyBy(this.storeBoughtList, 'storeId')
    const storeItem = _boughtObj[this._info.storeId]
    const addressDetails = this._info.addressDetails || '' // 未传参值为null，在字符串拼接会展示
    return { ...this._info, addressDetails, distance, distanceWithUnit, eatType, payMode, boughtCnt: storeItem ? Number(storeItem.cnt) : 0 }
  }

  /** 门店扩展属性 map */
  get storeExtInfoMap () {
    let obj: Record<string, any> = {}
    Object.keys(this._info.storeExtInfo || {}).forEach(infokey => {
      try {
        obj[infokey] = JSON.parse(this._info?.storeExtInfo[infokey])
      } catch (err) {
        obj[infokey] = this._info?.storeExtInfo[infokey]
      }
    })
    return obj
  }

  /** 门店桌台信息扩展信息 */
  get deskTimeColorInfo () {
    const { deskTimeColor, reservationPrintStatus, deskColorStatus } = this.storeExtInfoMap
    let obj = new Map()
    obj.set('addTime1', deskColorStatus === 'enable' ? deskTimeColor?.list[0] || { color: '#F1C21B', time: 30 } : null)
    obj.set('addTime2', deskColorStatus === 'enable' ? deskTimeColor?.list[1] || { color: '#DA1E28', time: 60 } : null)
    obj.set('reservationColor', reservationPrintStatus === 'enable' ? { color: '#24B3FF' } : null)
    return obj
  }

  /** 判断是否桌台颜色设置与打印颜色设置开启了其中一个，开启其中一个就需要runTime */
  get openRunTime () {
    const { deskColorStatus, reservationPrintStatus } = this.storeExtInfoMap
    return deskColorStatus === 'enable' || reservationPrintStatus === 'enable'
  }

  /** 门店列表 view */
  get viewStoreList (): IViewStore[] {
    if (['pos', 'kiosk'].includes(restaurantConfig.app)) {
      return this.storeList.map(store => ({ ...store, inSale: 1, status: 'inSale', googleLbsLat: 0, googleLbsLng: 0, countDownDiff: 0, baseTimeStamp: 0, eatType: ['dinein', 'togo'] }))
    } else {
      // 当前如果是列表中的显示模式 根据断定使用storeOrderMode 即门店支持的点餐模式而非桌码的模式
      const viewList = this.storeList.map(store => {
        let lbsLat = 0
        let lbsLng = 0
        let googleLbsLat = 0
        let googleLbsLng = 0
        const storeLat = Number(store.lbsLat)
        const storeLng = Number(store.lbsLng)
        if (store.lbsType === 'google') {
          googleLbsLat = storeLat
          googleLbsLng = storeLng
          const lbsB = coordtransform.wgs84tobd09(storeLat, storeLng)
          lbsLat = lbsB[0]
          lbsLng = lbsB[1]
        } else {
          lbsLat = storeLat
          lbsLng = storeLng
          const lbsG = coordtransform.bd09towgs84(storeLat, storeLng)
          googleLbsLat = lbsG[0]
          googleLbsLng = lbsG[1]
        }
        const { distance, distanceWithUnit } = (restaurantConfig?.lbs?.lat || (cartMobx.info.eatType === TEEatType.delivery && restaurantConfig.addressLbs?.lat)) ? getDistanceAndUnit(storeLat, storeLng, cartMobx.info.eatType === TEEatType.delivery && restaurantConfig.addressLbs?.lat ? restaurantConfig.addressLbs : undefined) : { distance: 0, distanceWithUnit: '' }
        let saleCnt = this.saleCntMap[store.storeId] || 0
        // TOGO
        const calcInSaleDown = calInSale(store.saleTime, store.timeZone, Date.now())
        const inSale = calcInSaleDown.inSale ? 1 : 0 as 0 | 1
        const countDownDiff = calcInSaleDown.isCountDown
        const baseTimeStamp = calcInSaleDown.valueTime
        // && !store.isMobileBookingOrder
        const status = !store.isMobileOrder ? 'closing' : inSale ? 'inSale' : 'resting' as 'closing' | 'inSale' | 'resting'
        // const eatType = Object.keys(pickBy(restaurantConfig.codeType === 'table' ? store.deskOrderMode : store.storeOrderMode)).filter(type => type === (restaurantConfig.codeType === 'table' ? 'dinein' : 'togo')) as ('dinein' | 'togo')[]
        const eatType = ('table_store'.includes(`${restaurantConfig?.codeType}`) ? ['dinein'] : [TEEatType.dinein, 'togo']) as ('dinein' | 'togo')[]
        const eatTypes = cloneDeep(eatType as TEEatType[])
        if (store?.openSelfDelivery) {
          eatTypes.push(TEEatType.delivery)
        }
        // 兼容数据 当前桌码只支持堂食，门店码只支持打包
        return {
          ...store,
          lbsLat,
          lbsLng,
          lbsType: 'baidu',
          googleLbsLat,
          googleLbsLng,
          distance,
          distanceWithUnit,
          inSale,
          countDownDiff,
          baseTimeStamp,
          status,
          saleCnt,
          eatType,
          eatTypes,
        }
      }).filter(store => {
        /** 门店关闭 */
        return store.status !== 'closing' && !!store.saleResourceInfo?.base
      })
      // 1. 营业中 - 休息中可预约 - 休息中 2. 距离
      let sortList = viewList
      if (restaurantConfig?.lbs?.lat || (cartMobx.info.eatType === TEEatType.delivery && restaurantConfig?.addressLbs?.lat)) {
        sortList = sortBy(viewList, 'distance')
      }
      //  + (store.isMobileBookingOrder ? 0 : 1) 暂不考虑可预约的case
      sortList = sortBy(sortList, store => (store.status !== 'resting' ? 0 : 10))
      /** 开启外卖排序 */
      if (restaurantConfig.codeType === 'brand' && cartMobx.info.eatType === TEEatType.delivery) {
        sortList = sortBy(sortList, (store) => store.openSelfDelivery ? 0 : 10)
      }
      /** 开启堂食排序 */
      if (restaurantConfig.codeType === 'brand' && cartMobx.info.eatType === TEEatType.dinein) {
        sortList = sortBy(sortList, (store) => store.openDinein ? 0 : 10)
      }
      /** 开启自提排序 */
      if (restaurantConfig.codeType === 'brand' && cartMobx.info.eatType === TEEatType.pickup) {
        sortList = sortBy(sortList, (store) => store.openPickup ? 0 : 10)
      }
      if (restaurantConfig.storeId) {
        sortList = sortBy(sortList, (store) => store.storeId === restaurantConfig.storeId ? 0 : 1)
      }
      return sortList
    }
  }

  /** 是否有开通外卖门店 */
  get hasDeliveryStore () {
    return !!this.viewStoreList?.filter((store) => store.openSelfDelivery === 1).length
  }

  /** 是否有开通外卖且开通拼单的门店 */
  get hasDeliveryStoreAndBuyTogether () {
    return !!this.viewStoreList?.filter((store) => store.openSelfDelivery === 1 && store.isOpenBuyTogether === 1).length
  }

  /** 是否有开通品牌码堂食门店 */
  get hasBrandDineinStore () {
    return true
  }

  /** storeList map */
  get storeIdToStore () {
    return keyBy(this.storeList, 'storeId')
  }

  /** viewStoreList map */
  get storeIdToViewStore () {
    return keyBy(this.viewStoreList, 'storeId')
  }

  /** 点单流程 */
  get storeSceneConfig () {
    const eatType = cartMobx.info.eatType === 'togo' ? 'dinein' : cartMobx.info.eatType
    const storeConfig: any = this.storeSceneMap?.[this.info.storeId + '']?.[eatType] || {
      payMode: 0,
      diningMode: 1,
    }
    // 服务员下单大开关
    const allConfirmOrders = this.info.allConfirmOrders || 0
    // 桌码 需要服务员下单
    const posAllConfirmOrders = allConfirmOrders && this.info.posAllConfirmOrders === 1 ? 1 : 0
    // 会员快速下单，需要开启上方配置
    const memberConfirmOrders = allConfirmOrders && this.info.posMemberConfirmOrders === 1 ? 1 : 0
    // 桌码后付费场景顾客结帐方式
    const openAfterPayCustomerPay = this.info.openAfterPayCustomerPay === 1 ? 1 : 0
    return {
      payMode: restaurantConfig.codeType && ['brand', 'store'].includes(restaurantConfig.codeType) ? 0 : storeConfig?.payMode,
      diningMode: storeConfig?.diningMode,
      confirmOrders: restaurantConfig.codeType && ['brand', 'store'].includes(restaurantConfig.codeType) ? 0 : posAllConfirmOrders,
      memberConfirmOrders,
      openAfterPayCustomerPay: restaurantConfig.codeType && ['brand', 'store'].includes(restaurantConfig.codeType) ? 0 : openAfterPayCustomerPay,
    }
  }

  /** 根据点餐类型的门店列表 */
  get eatTypeStoreMap (): TEatTypeStoreMap {
    const togoStores = this.viewStoreList.filter(store => store.storeOrderMode.togo && store.status !== 'closing')
    const dineinStores = this.viewStoreList.filter(store => store.storeOrderMode.dinein && store.status !== 'closing')
    const togoConsumedStores = sortBy(togoStores.filter(store => store.saleCnt), (store) => -(store.saleCnt || 0))
    const dineinConsumedStores = sortBy(dineinStores.filter(store => store.saleCnt), (store) => -(store.saleCnt || 0))
    return {
      togo: {
        nearbyStores: togoStores,
        consumedStores: togoConsumedStores
      },
      dinein: {
        nearbyStores: dineinStores,
        consumedStores: dineinConsumedStores
      }
    }
  }

  /** 置入已初始化的数据，针对手机点餐先预加载的模式优化（其他端暂务使用该方法） */
  async initList (data?: any) {
    const query: any = {
      brandId: restaurantConfig.brandId || 0
    }
    try {
      // 获取的时候获取全量的，根据当前是否有STOREID标记来筛选选中的门店
      const res = data || await StoreAPI.getHomePage(query)
      if (res && !res.error) {
        const { brandInfo, storeList = [] } = res
        // TODO 为了确保时序的正确性，使用第一家门店的timezone作为品牌的timezone
        // const brand = Object.assign(brandInfo, { timeZone: storeList.length ? storeList[0].timeZone : 'Asia/Shanghai' })
        brandInfo.logo = brandInfo.logo ? (format.toPic(brandInfo.logo)?.url || defaultConfig.brandLogo) : defaultConfig.brandLogo
        this.setBrand(brandInfo)
        this.setStoreCityList(brandInfo.cityNames)
        if (storeList.length) {
          this.setStoreList(storeList)
        }
      }
      return res
    } catch (error) {
      return false
    }
  }

  /** 初始化通过城市名称获取区域门店列表 */
  async initToCity (cityName: string = '') {
    this.cityName = cityName
    restaurantCenter.setConfig({
      cityName
    })
    try {
      const res = await (StoreAPI as any).getStoreList?.({ cityName })
      if (!res.error) {
        this.setStoreList(res)
      }
    } catch (error) {
    }
    return true
  }

  /** 初始化全部门店的点单流程 */
  async initStoreScenes () {
    try {
      /** 当前品牌下场景 */
      // const sceneListRes = await StoreAPI.getMobileServiceModes()
      const sceneListRes: any = await StoreAPI.getMobileServiceModes()
      if (!sceneListRes.error) {
        const storeSceneMap: Record<number, any> = {}
        const storeEatTypes: Record<number, any> = {}
        forEach(sceneListRes, (store: any, storeId: number) => {
          const eatTypes = map(store, (item: any) => item.eatType)
          storeEatTypes[storeId] = eatTypes
          storeSceneMap[storeId] = keyBy(map(store, (item: any) => item), 'eatType')
        })
        runInAction(() => {
          this.storeEatTypeMap = storeEatTypes
          this.storeSceneMap = storeSceneMap
        })
        return true
      }
    } catch (error) {
      console.log(error)
    }
    return false
  }

  /** 门店列表数据初始化 */
  setStoreList (storeList: any[] = []) {
    if (storeList.length) {
      try {
        this.storeList = storeList.map((storeInfo: any) => {
          const storeEatTypes = this.storeEatTypeMap[storeInfo.storeId] || []
          /** 门店点单流程 */
          const storeSceneMap = this.storeSceneMap[storeInfo.storeId] || {}
          const timeZone = storeInfo.timeZone
          /** 开通外卖 */
          const openSelfDelivery = storeEatTypes.includes(TEEatType.delivery) ? 1 : 0
          /** 开通堂食 */
          const openDinein = storeEatTypes.includes(TEEatType.dinein) ? 1 : 0
          /** 开通自提 */
          const openPickup = storeEatTypes.includes(TEEatType.pickup) ? 1 : 0
          /** 开启手机点单 */
          const isMobileOrder = !!storeEatTypes.length

          /**
           * 临时关闭点单流程
           */
          const pauseStartTime = ddayjs().format('YYYY-MM-DD HH:mm:ss')
          // 堂食
          const pauseReserveOrderTime = openDinein && storeSceneMap[TEEatType.dinein]?.storeRebootTime ? { startTime: storeSceneMap[TEEatType.dinein]?.storePauseTime || pauseStartTime, endTime: storeSceneMap[TEEatType.dinein]?.storeRebootTime, status: 0 } : {}
          // 自提
          const pausePickupOrderTime = openPickup && storeSceneMap[TEEatType.pickup]?.storeRebootTime ? { startTime: storeSceneMap[TEEatType.pickup]?.storePauseTime || pauseStartTime, endTime: storeSceneMap[TEEatType.pickup]?.storeRebootTime, status: 0 } : {}
          // 自营外卖
          const pauseSelfDeliveryOrderTime = openSelfDelivery && storeSceneMap[TEEatType.delivery]?.storeRebootTime ? { startTime: storeSceneMap[TEEatType.delivery]?.storePauseTime || pauseStartTime, endTime: storeSceneMap[TEEatType.delivery]?.storeRebootTime, status: 0 } : {}
          if (pauseSelfDeliveryOrderTime?.endTime) {
            pauseSelfDeliveryOrderTime.status = checkInTime(pauseSelfDeliveryOrderTime.startTime, pauseSelfDeliveryOrderTime.endTime, timeZone)
          }
          if (pauseReserveOrderTime?.endTime) {
            pauseReserveOrderTime.status = checkInTime(pauseReserveOrderTime.startTime, pauseReserveOrderTime.endTime, timeZone)
          }
          if (pausePickupOrderTime?.endTime) {
            pausePickupOrderTime.status = checkInTime(pausePickupOrderTime.startTime, pausePickupOrderTime.endTime, timeZone)
          }
          // 品牌码预约堂食 老的预约堂食开关依然生效
          if (!pauseReserveOrderTime?.endTime && restaurantConfig.codeType === 'brand' && openDinein) {
            const pauseReserveOrderTimeOld = JSON.parse(storeInfo?.storeExtInfo?.pauseReserveOrderTime || '{}')
            if (pauseReserveOrderTimeOld?.endTime) {
              pauseReserveOrderTime.startTime = pauseReserveOrderTimeOld.startTime
              pauseReserveOrderTime.endTime = pauseReserveOrderTimeOld.endTime
              pauseReserveOrderTime.status = checkInTime(pauseReserveOrderTime.startTime as any, pauseReserveOrderTime.endTime as any, timeZone)
            }
          }
          // 总开关 兼容老功能
          const pauseMobileOrderTime = { startTime: '', endTime: '', all: 0, togo: 0 }
          // if (pauseMobileOrderTime?.startTime && pauseMobileOrderTime?.endTime) {
          //   const now = Date.now()
          //   const { startTime, endTime } = pauseMobileOrderTime
          //   const inTime = ddayjs(startTime, timeZone).valueOf() <= now && now < ddayjs(endTime, timeZone).valueOf()
          //   pauseMobileOrderTime.all = pauseMobileOrderTime.all && inTime ? 1 : 0
          //   pauseMobileOrderTime.togo = pauseMobileOrderTime.togo && inTime ? 1 : 0
          // } else {
          //   pauseMobileOrderTime.all = 0
          //   pauseMobileOrderTime.togo = 0
          // }

          const bookingOrderOption = JSON.parse(storeInfo?.storeExtInfo?.bookingOrderOption || '{}')
          const waitingTimeConfig = JSON.parse(storeInfo?.storeExtInfo?.waitingTimeConfig || '{}')
          const preOrderCustomTips = JSON.parse(storeInfo?.storeExtInfo?.preOrderCustomTips || '""')
          const deliveryTimeConfig = JSON.parse(storeInfo?.storeExtInfo?.deliveryTimeConfig || '[]')
          const selfDeliveryConfig = deliveryTimeConfig.find((item: any) => item.channel === 'selfDelivery') || {}
          /** 配送范围根据配送距离排序 */
          if (selfDeliveryConfig.deliveryArea?.length) {
            selfDeliveryConfig.deliveryArea = sortBy(selfDeliveryConfig.deliveryArea, 'deliveryDistance')
          }
          const quicklyRemarkConfig = JSON.parse(storeInfo?.storeExtInfo?.quicklyRemarkConfig || '{}')
          const noticeConfig = JSON.parse(storeInfo?.storeExtInfo?.noticeConfig || '{ "showMktInfo": 1 }')
          const diningNumberConfig = JSON.parse(storeInfo?.storeExtInfo?.diningNumberConfig || '{ "status": 0, "kids": 0, "kidsStandard": 1 }')
          const requiredPhoneConfig = JSON.parse(storeInfo?.storeExtInfo?.requiredPhoneConfig || `{ "mobilePayFirst": ${bo === 'cn' ? 0 : 1}, "mobilePayLast": 1, "scanPayFirst": ${bo === 'cn' ? 0 : 1}, "scanPayLast": 0 }`)
          const buyTogetherEatTypes = [] // 当前门店支持拼单的就餐方式
          const openSendServiceRing = storeInfo.storeExtInfo?.openSendServiceRing === '1' ? 1 : 0
          const allConfirmOrders = storeInfo.storeExtInfo?.allConfirmOrders === '1' ? 1 : 0
          // 语音服务 走品牌配置
          const voiceConfig = this.brand?.extInfo?.voiceConfig ? JSON.parse(this.brand.extInfo.voiceConfig) : storeInfo?.storeExtInfo?.voiceConfig ? JSON.parse(storeInfo?.storeExtInfo?.voiceConfig || '{}') : {
            canSearchProduct: storeInfo.storeExtInfo?.isOpenVoiceService === '1' ? 1 : 0
          }
          // noticeConfig
          if (noticeConfig?.showCustom) {
            const nowDate = ddayjs(timeZone).format('YYYY-MM-DD')
            const nowTime = ddayjs(timeZone).format('HH:mm')
            const { type: typeDate, start: startDate, end: endDate } = noticeConfig.showCustom.date || {}
            const { type: typeTime, start: startTime, end: endTime } = noticeConfig.showCustom.time || {}
            const inDate = !noticeConfig.showCustom.date || (!(typeDate !== 'always' && !(startDate <= nowDate && nowDate < endDate)))
            const inTime = !noticeConfig.showCustom.time || (!(typeTime !== 'always' && !((startTime || '00:00') <= nowTime && nowTime < (endTime || '24:00'))))
            noticeConfig.showCustom.content = inDate && inTime ? noticeConfig.showCustom.content : ''
          }
          // 开启拼单,获取当前门店支持的就餐方式
          if (storeInfo?.storeExtInfo?.isOpenBuyTogether === '1') {
            (!pausePickupOrderTime.status) && buyTogetherEatTypes.push(TEEatType.pickup);
            (!pauseSelfDeliveryOrderTime.status && openSelfDelivery) && buyTogetherEatTypes.push(TEEatType.delivery)
          }
          // 授权包信息
          const saleResourceInfo = keyBy(storeInfo?.saleResourceList || [], 'saleResourceKey')
          // 去除非togo的场景
          // const eatTypeObj = JSON.parse(storeInfo?.storeExtInfo?.storeOrderMode || '{}')
          // delete eatTypeObj.dinein
          // delete eatTypeObj.delivery
          return {
            ...pick(storeInfo, ['storeName', 'storeId', 'status', 'city', 'address', 'addressDetails', 'lbsLat', 'lbsLng', 'lbsType', 'diningMode', 'payMode', 'timeZone', 'tel', 'storeExtInfo', 'cityId']),
            // isMultiMenu: 1,
            isMobileOrder,
            saleTime: storeInfo?.saleTime ? JSON.parse(storeInfo?.saleTime) : null,
            /** 当前点单流程开启的就餐方式 */
            sceneEatTypes: storeEatTypes,
            storeOrderMode: JSON.parse(storeInfo?.storeExtInfo?.storeOrderMode || '{}'),
            deskOrderMode: JSON.parse(storeInfo?.storeExtInfo?.deskOrderMode || '{}'),
            deskBackgroundColor: storeInfo?.storeExtInfo?.deskBackgroundColor || '#EAEAEF',
            qrcodePayMode: storeInfo?.storeExtInfo?.dineinQrcode ? JSON.parse(storeInfo.storeExtInfo?.dineinQrcode || '{}').payMode : 1,
            // 需要pos确认订单
            posAllConfirmOrders: storeInfo?.storeExtInfo?.posAllConfirmOrders === '1' ? 1 : 0,
            // 用户可直接下单
            posMemberConfirmOrders: storeInfo?.storeExtInfo?.posMemberConfirmOrders === '1' ? 1 : 0,
            mobileAdvert: JSON.parse(storeInfo?.mobileAdvert || '{}'),
            commonUseTime: (bookingOrderOption.commonUseTime || []).sort((a: any, b: any) => {
              if (a > b) {
                return 1
              } else if (a === b) {
                return 0
              }
              return -1
            }),
            preparationTime: bookingOrderOption.preparationTime || [],
            printTime: bookingOrderOption.printTime || {},
            brandId: restaurantConfig.brandId,
            // 品牌码进入，门店才支持预约点餐
            isMobileBookingOrder: restaurantConfig.codeType === 'brand' && storeInfo?.isMobileBookingOrder === 1,
            // 将所有的门店都认为是先付费的
            payMode: 0,
            // 关闭仅下单不付款的case
            storeOrderType: 0,
            longBookingTime: bookingOrderOption.longBookingTime || {},
            smallBookingTime: bookingOrderOption.smallBookingTime || {},
            bookingIntervalTime: bookingOrderOption.bookingIntervalTime || {},
            bookingWeeks: bookingOrderOption.bookingWeeks || [1, 2, 3, 4, 5, 6, 7],
            /** 放恶意大开关 */
            allConfirmOrders,
            // 是否开启多人点餐
            openMultiPersonOrdering: storeInfo?.storeExtInfo?.closeMultiPersonOrdering === '1' ? 0 : 1,
            // 是否开启桌码后付费场景支持顾客付款
            openAfterPayCustomerPay: storeInfo?.storeExtInfo?.openAfterPayCustomerPay === '1' ? 1 : 0,
            // 桌码后付费场景顾客结帐方式
            customerCheckoutWay: storeInfo?.storeExtInfo?.customerCheckoutWay === '1' ? 1 : 0,
            // 预计等待时间配置
            waitingTimeConfig: waitingTimeConfig,
            preOrderCustomTips: preOrderCustomTips,
            // 是否开通自营外卖
            openSelfDelivery,
            // 是否开通堂食
            openDinein,
            // 是否开通自提
            openPickup,
            // 自营外卖配置
            selfDeliveryConfig: selfDeliveryConfig,
            // 打包费税id
            boxTaxCategoryId: storeInfo.storeExtInfo?.boxTaxCategoryId,
            // 是否开启顾客在手机上呼叫服务员
            openSendServiceRing,
            // 语音服务配置
            // isOpenVoiceService: storeInfo.storeExtInfo?.isOpenVoiceService === '1' ? 1 : 0,
            voiceConfig,
            // 是否开启拼单
            isOpenBuyTogether: storeInfo.storeExtInfo?.isOpenBuyTogether === '1' ? 1 : 0,
            // 手机点餐暂时关闭
            pauseMobileOrderTime: pauseMobileOrderTime,
            // 自营外卖暂时关闭
            pauseSelfDeliveryOrderTime: pauseSelfDeliveryOrderTime,
            // 店外预约点单暂时关闭 品牌码堂食
            pauseReserveOrderTime: pauseReserveOrderTime,
            // 自提点单暂时关闭 品牌码自提
            pausePickupOrderTime: pausePickupOrderTime,
            // 快捷备注
            quicklyRemarkConfig: quicklyRemarkConfig,
            // 开启单品备注
            isOpenSingleRemark: storeInfo.storeExtInfo?.isOpenSingleRemark === '1' ? 1 : 0,
            // 强留手机号
            requiredPhoneConfig,
            // 门店公告
            noticeConfig: noticeConfig,
            // 就餐人数配置
            diningNumberConfig: diningNumberConfig,
            // 开启品牌码堂食
            openBrandDinein: storeInfo.storeExtInfo?.isOpenBrandDinein === '1' ? 1 : 0,
            // 品牌码堂食模式
            brandDiningMode: storeInfo.storeExtInfo?.brandDiningMode === '2' ? 2 : 1,
            // 拼单支持的就餐方式
            buyTogetherEatTypes,
            // 授权包map
            saleResourceInfo,
            // 是否关闭堂食订单餐品打包
            closeDineinTogo: storeInfo.storeExtInfo?.closeDineinTogo === '1' ? 1 : 0,
            // 是否开通新供应链
            isNewSupply: storeInfo.storeExtInfo.isNewSupply === '1' ? 1 : 0
          } as any
        })
      } catch (error) {
        console.log(error)
      }
      if (restaurantConfig.storeId) {
        const theStore = this.viewStoreList.find(store => store.storeId === restaurantConfig.storeId)
        if (theStore) {
          this.initInfo(theStore)
        }
      }
    }
  }

  /** 品牌信息 */
  setBrand (brand: IBrand) {
    this.brand = brand
    restaurantCenter.emit(restaurantCenter.RESTAURANT_EVENT.BRAND_CHANGED, brand)
  }

  /** 切换门店 */
  async initInfo (data: IViewStore) {
    this._info = cloneDeep({ ...this.info, ...data })
    restaurantCenter.setConfig({ storeId: this._info.storeId })
    if (restaurantConfig.app === 'mobile' && this._info?.waitingTimeConfig?.status) {
      const mealsWaiting = await StoreAPI.getMealsWaitingTime(this._info.storeId)
      this.setWaitingTime({ mealsWaiting, isInit: true })
    } else {
      this.setWaitingTime({ isInit: true })
    }
    /** 触发门店修改事件 */
    restaurantCenter.emit(restaurantCenter.RESTAURANT_EVENT.STORE_CHANGED, this._info)
  }

  /** 设置订单排队时长 */
  async setWaitingTime (data?: {
    mealsWaiting?: any;
    isInit?: boolean;
  }) {
    if (data?.mealsWaiting) {
      Object.assign(this._info, {
        mealsWaitingTime: { ...data?.mealsWaiting }
      })
    } else {
      Object.assign(this._info, {
        mealsWaitingTime: null
      })
    }
    if (!data?.isInit) {
      restaurantCenter.emit(restaurantCenter.RESTAURANT_EVENT.STORE_CHANGED, this._info)
    }
  }

  /** 获取云端一家门店的信息，并置入info 针对pos端使用 */
  async init () {
    // 因为有异步流程为了加快同时获取先置入品牌 门店
    this.info.brandId = restaurantConfig.brandId
    this.info.storeId = restaurantConfig.storeId
    const data = await StoreAPI.getStore(this.info.brandId).then((data: any) => {
      runInAction(() => {
        this.storeList = data
        const theStore = this.viewStoreList.find(store => store.storeId === restaurantConfig.storeId)
        if (theStore) {
          // TODO 为了确保时序的正确性，使用第一家门店的timezone作为品牌的timezone
          this.setBrand({
            brandId: theStore.brandId,
            brandName: theStore.brandName || '',
            logo: (theStore as any).logo,
            bo: (theStore as any).bo,
            timeZone: theStore.timeZone
          })
          // deal store
          const deliveryTimeConfig = JSON.parse(theStore?.storeExtInfo?.deliveryTimeConfig || '[]')
          theStore.selfDeliveryConfig = deliveryTimeConfig.find((item: any) => item.channel === 'selfDelivery') || {}
          theStore.boxTaxCategoryId = theStore?.storeExtInfo?.boxTaxCategoryId
          theStore.saleResourceInfo = keyBy(theStore?.saleResourceList || [], 'saleResourceKey')
          theStore.isNewSupply = theStore?.storeExtInfo?.isNewSupply === '1' ? 1 : 0
          this.initInfo(theStore)
        }
      })
    })
    return data
  }

  /** 门店售卖数量 */
  setSaleCntMap (saleCntMap: {
    [storeId: number]: number;
  }) {
    this.saleCntMap = saleCntMap
  }

  /** 设置可切换的品牌码就餐方式 */
  setOpenBrandEatTypes (eatTypes: ('dinein' | 'pickup' | 'delivery')[]) {
    this.openBrandEatTypes = eatTypes
  }

  /** 获取会员已购餐品数据 */
  async getStoreBought (memberId: string) {
    const res = await StoreAPI.getStoreByMember({
      memberId,
      startTime: ddayjs().subtract(1, 'month').startOf('day').format('YYYY-MM-DD'),
      endTime: ddayjs().endOf('day').format('YYYY-MM-DD'),
    }).then((data: any) => {
      runInAction(() => {
        this.storeBoughtList = reverse(sortBy(data.content || [], 'recentDate'))
      })
    })
    return res
  }

  async updateStoreHandOverType (type: 'person' | 'time') {
    runInAction(() => {
      this._info.storeExtInfo = {
        ...this._info.storeExtInfo,
        shiftType: type
      }
    })
  }

  async changeStoreHandOverType (type: 'person' | 'time') {
    try {
      const res: any = await StoreAPI.updateStoreExt({
        storeId: this._info.storeId,
        attrName: 'shiftType',
        attrValue: type,
        attrType: 'add_store'
      })
      if (res && res.result && res.result === 'success') {
        runInAction(() => {
          this._info.storeExtInfo = {
            ...this._info.storeExtInfo,
            shiftType: type
          }
        })
      }
    } catch (err) {

    }
  }

  /** 设置品牌下全部门店所属城市列表 */
  setStoreCityList (cityList: string[] = []) {
    const list = sortCityNames(cityList)
    this.storeCityList = [...list]
  }

  /** 手动设置城市 */
  setStoreCity (cityName: string) {
    this.initToCity(cityName)
  }
}

export default new Store()
